import * as React from "react"
import { CdnVendor } from "@modules/graphql/types"
import {
  Card,
  CardHeader,
  CardSection,
  Button,
  ThemeCss,
} from "gatsby-interface"
import { ConnectedDomains, SslCertificates } from "@modules/cdn/gatsbyCloudCdn"
import { useSiteDetailsFieldsFragment } from "@modules/site/shared/fragments.generated"
import { useHostingDetailsForSiteQuery } from "@modules/cdn/gatsbyCloudCdn/queries.generated"
import { SiteSettingsSection, SiteSettingsSectionLabel } from "../constants"

export type DomainsProps = {
  siteId: string
  organizationId: string
}

export function Domains({ siteId, organizationId }: DomainsProps) {
  const { data: siteData } = useSiteDetailsFieldsFragment(siteId)
  const [showForm, setShowForm] = React.useState<boolean>(false)

  const isGatsbyHostingOn =
    siteData?.cdnIntegrations?.find(
      item => item.connected === true && item.vendor === CdnVendor.CloudCdn
    ) || true

  const hasPermissionToEdit = siteData?.permissions?.sites?.edit || undefined

  const { data: hostingData } = useHostingDetailsForSiteQuery({
    variables: { siteId },
    fetchPolicy: `cache-only`,
  })

  const data = hostingData
  const hostingDetails = data?.hostingDetailsForSite?.[0]
  const hastCustomDomain = hostingDetails?.domains?.some(
    item => !item.cloudCdnDefault
  )

  const handleClick = () => {
    setShowForm(true)
  }

  if (!isGatsbyHostingOn || !hostingDetails) {
    return null
  }

  return (
    <Card id={SiteSettingsSection.Domains}>
      <CardHeader
        title={SiteSettingsSectionLabel[SiteSettingsSection.Domains]}
        css={headerCss}
      >
        <div css={headerSuppCss}>
          {hasPermissionToEdit && (
            <Button variant="PRIMARY" size="M" onClick={handleClick}>
              Add domain
            </Button>
          )}
        </div>
      </CardHeader>
      <CardSection applyPaddingTop={false}>
        {hostingDetails.domains && (
          <ConnectedDomains
            siteId={siteId}
            organizationId={organizationId}
            hostingDetails={hostingDetails}
            allowToEdit={hasPermissionToEdit}
            showForm={showForm}
            onClose={() => setShowForm(false)}
          />
        )}

        {hostingDetails.certificates && hastCustomDomain && (
          <SslCertificates
            siteId={siteId}
            hostingDetails={hostingDetails}
            allowToEdit={hasPermissionToEdit}
            organizationId={organizationId}
          />
        )}
      </CardSection>
    </Card>
  )
}

/* styles */

const headerCss: ThemeCss = theme => ({
  flexWrap: `wrap`,
})

const headerSuppCss: ThemeCss = _theme => ({
  display: `flex`,
  alignItems: `center`,
})
